export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Setting.vue?vue&type=template&id=c5062c04&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/Setting.vue?vue&type=template&id=c5062c04&
// module id = null
// module chunks = 